import { render, staticRenderFns } from "./editCollectionCompanyComponent.vue?vue&type=template&id=6f6fb189&"
import script from "./editCollectionCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./editCollectionCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports